import React from 'react'

import Icon from 'components/util/Icon'

export default function PremiumLabel({ children='Premium Plan Only' }) {
  return (
    <div className="premium">
      <Icon icon="shield" />
      {children}
    </div>
  )
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Form/PremiumLabel.js